module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/icon_1_text_x32-c126a.png";